// extracted by mini-css-extract-plugin
module.exports = {"head":"ZZQVf","body":"Ntrmn","thumbnail":"Dl9M0","image":"p5O0u","title":"XaJuT","tags":"FSIVw","count":"u9A35","moreLink":"PbVhJ","buttonWrapper":"FUvLp"};